import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const PrequalOffer = loadable(() => import('./PrequalOffer'), {
  fallback: <LoadingScreen />,
});

export default PrequalOffer;
